import { render } from "./FeatherUserSvg.vue?vue&type=template&id=467a587a"
const script = {}
script.render = render

export default script